import { FC } from "react";
import {
  AspectRatio,
  Box,
  Container,
  Flex,
  Heading,
  Text,
} from "@radix-ui/themes";

import useViewportWidth from "@/hooks/useViewportWidth";

interface SingleZoneCoverProps {
  logoURL: string;
  coverURL?: string;
  videoURL?: string;
  title: string;
  tagline: string;
  desc: string;
}

export const SingleZoneCover: FC<SingleZoneCoverProps> = ({
  coverURL,
  logoURL,
  videoURL,
  title,
  tagline,
  desc,
}): JSX.Element => {
  const isMobile = useViewportWidth(768);
  const isTablet = useViewportWidth(1280);

  return (
    <Box className="cover-image align-full">
      <AspectRatio ratio={isMobile ? 2 / 3 : isTablet ? 3 / 3 : 2.5 / 1}>
        {videoURL ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          >
            <source src={videoURL} type="video/mp4" />
          </video>
        ) : (
          <img
            src={coverURL}
            alt={title}
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
            }}
          />
        )}
      </AspectRatio>

      <Box className="cover-image__content" pb="5">
        <Container px={{ initial: "4", md: "2", xl: "0" }}>
          <Flex direction="column" gap="6">
            {/* Logo */}
            <Box>
              <img
                src={logoURL}
                alt={title}
                width={300}
                style={{
                  width: "250px",
                  height: "auto",
                }}
              />
            </Box>
            {/* Title and Description */}
            <Flex direction="column" gap="3">
              <Flex align="center" mb="0" gap="3">
                <Heading as="h1" my="0">
                  {tagline}
                </Heading>
              </Flex>
              <Text as="p" size="3">
                {desc}
              </Text>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </Box>
  );
};
